import React from 'react';

interface LogoPlaceholderProps {
  name: string;
  bgColor?: string;
  textColor?: string;
}

const LogoPlaceholder: React.FC<LogoPlaceholderProps> = ({ 
  name, 
  bgColor = 'bg-gradient-to-br from-blue-500 to-blue-600',
  textColor = 'text-white'
}) => {
  const initials = name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className={`w-full h-full ${bgColor} rounded-lg flex items-center justify-center`}>
      <span className={`${textColor} text-2xl font-bold`}>{initials}</span>
    </div>
  );
};

export default LogoPlaceholder;